import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CanActivateGuard } from './Services/can-activate-guard';
import { localDataService } from './Services/localDataServices';
declare var $: any;  //定义jquery
declare var async: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  providers: [CanActivateGuard, localDataService],
  styleUrls: ['./app.component.css']
})

export class AppComponent {
  title = 'app';
  perMi: boolean = true;
  toggleclass: boolean = true;
  status: any;
  userName: any;
  passWord: any;
  oneAtATime: boolean;
  isIdentPage: boolean = false;
  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _canActivateGuard: CanActivateGuard,
    private _localDataService: localDataService,
  ) {

  }

  ngOnInit() {
    $(function () {
      $('.regist-title li a').click(function () {
        $(this).parent("li").children("div").show();
        $(this).parent("li").siblings().children("div").hide();
      })
    });

    // 登录注册找回密码新密码切换
    $(function () {
      $('.regist-footer span').click(function () {
        $('#registModal').modal('hide')
      });
      $('.login-footer span').click(function () {
        $('#loginModal').modal('hide')
      })
    })















    $("#loadingimgindex").hide()
    if (sessionStorage.getItem("perMi") == "1") {
      this.perMi = true;
      this.nickName = sessionStorage.getItem("nickName");
    } else {
      if (window.location.pathname.indexOf('identification') > -1) {
        this.isIdentPage = true;
        return
      }
      this.perMi = false;
      this._router.navigateByUrl("")
    }






  }

  nickName: any;
  authError: any = "";
  loginbtn() {

    var name = $('input[name="name"]');
    var password = $('input[name="password"]');

    if (name.val() == '') {
      name.focus();
      this.authError = '请输入手机号或用户名';
    } else if (password.val() == '') {
      password.focus();
      this.authError = '请输入密码';
    } else {
      this._canActivateGuard.login(name.val(), password.val())
        .then(data => {
          this.status = data;
          if (this.status.code == 200) {
            $("#loginModal").hide();
            sessionStorage.setItem("token", this.status.data.token);    //token   
            this.perMi = true;
            sessionStorage.setItem("perMi", "1");
            //获取cobizid


            this._localDataService.getThisCompanyHaveSomeType(this.status.data.token)
              .then(data => {
                this.status = data;
                if (this.status.status) {
                  sessionStorage.setItem("coBizId", JSON.stringify(this.status.data));
                  console.log(this.status.data)
                  window.location.reload()
                }
              }).catch(err => {
                console.log(err);
              });


          } else {
            this.authError = this.status.msg
          }
        }).catch(err => {
          console.log(err);
        });
    }



  }

  logoutbtn() {
    this.perMi = false;
    this.authError = "";
    sessionStorage.setItem("perMi", "0");
    sessionStorage.setItem("token", "");
    sessionStorage.setItem("nickName", "");
    sessionStorage.setItem("coBizId", "");
    this._router.navigateByUrl("")
    window.location.reload()
  }








}



// WEBPACK FOOTER //
// /srv/jenkins-test/workspace/dev-doc-web/src/app/app.component.ts